import { AfterViewInit, Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { CalendarView, DatePickerComponent, DatePickerModule } from '@progress/kendo-angular-dateinputs';
import { QPointDateFormat, QPointDateFormatPipe } from '@qpoint/i18n';
import { addDays, addMonths, addYears, subDays, subMonths, subYears } from 'date-fns';
import { QPointToolbarButtonComponent } from '../toolbar-button/toolbar-button.component';

@Component({
    selector: 'qpoint-toolbar-dateslider',
    templateUrl: './toolbar-dateslider.component.html',
    styleUrls: ['./toolbar-dateslider.component.scss'],
    imports: [
        QPointToolbarButtonComponent,
        DatePickerModule,
        QPointDateFormatPipe
    ]
})
export class QPointToolbarDatesliderComponent implements OnInit, AfterViewInit {
  public _date: Date = new Date();
  public format =  QPointDateFormat.WrittenMonthWithDayAndYear;
  public datePickerDate = this._date;
  private _dateFormat: QPointDateFormat = null;

  @Input()
  set date(date: string) {
    this._date = new Date(date);
    this.datePickerDate = this._date;
  }

  get date(): string {
    return this._date.toUTCString();
  }

  @Input()
  set dateFormat(dateFormat: QPointDateFormat) {
    this._dateFormat = dateFormat;
    this.updateDateFormat();
  }

  get dateFormat(): QPointDateFormat {
    return this._dateFormat;
  }

  @Input()
  activeView: CalendarView = 'month';

  @Input()
  bottomView: CalendarView = 'month';

  @Output() dateChanged: EventEmitter<Date> = new EventEmitter();

  @ViewChild('datePicker')
  public datePicker: DatePickerComponent;

  @ViewChild('dateSliderContainer', {read: ViewContainerRef})
  public containerRef: ViewContainerRef;

  @HostListener('window:resize')
  public onWindowResize(): void {
    this.updateDateFormat();
  }

  ngAfterViewInit(): void {
    this.datePicker.popupSettings = {appendTo: this.containerRef}
  }

  ngOnInit(): void {
    this.updateDateFormat();
  }

  public onDateNext(): void {
    switch(this.bottomView) {
      case 'month':
        this._date = addDays(this._date, 1);
        break;
      case 'year':
        this._date = addMonths(this._date, 1);
        break;
      case 'decade':
        this._date = addYears(this._date, 1);
        break;
    }
    this.dateChanged.emit(this._date);
    this.updateDatePicker();
  }

  public onDatePrevious(): void {
    switch(this.bottomView) {
      case 'month':
        this._date = subDays(this._date, 1);
        break;
      case 'year':
        this._date = subMonths(this._date, 1);
        break;
      case 'decade':
        this._date = subYears(this._date, 1);
        break;
    }
    this.dateChanged.emit(this._date);
    this.updateDatePicker();
  }

  public onValueInPickerChanged(newDate: Date): void {
    this.dateChanged.emit(newDate);
    this._date = newDate;
  }

  public updateDateFormat(): void {
    if (this.dateFormat) {
      this.format = this.dateFormat;
      return;
    }
    if (window.innerWidth < 1200) {
      this.format = QPointDateFormat.ShortDate;
    } else {
      this.format = QPointDateFormat.DayOfWeekWithShortDate;
    }
  }

  public toggleDatePicker() {
    this.datePicker.toggle();
  }

  private updateDatePicker() {
    this.datePickerDate = null;
    setTimeout(() => this.datePickerDate = this._date, 1);
    if (this.datePicker.show) {
      this.datePicker.toggle();
    }
  }
}
